import React from 'react';

import FormSection from 'containers/FormSectionContainer';
import FieldSet from 'containers/FieldSetContainer';
import FormField from 'containers/FormField';
import ConditionalSection from 'containers/ConditionalSection';
import RadioButtonGroup from 'components/RadioButtonGroup';
import Datepicker from 'components/Datepicker';
import SelectField from 'components/SelectField';

import { fieldIs, fieldExists } from 'lib/conditions';

import FormProvider from 'routes/Documents/containers/FormProvider';
import TextFieldArea from 'components/TextFieldArea';
import TextFieldBox from 'components/TextFieldBox';

const optId = opt => `rehabilitation.opts.${opt}`;

const RehabilitationForm = props => (
  <FormProvider {...props}>
    <FormSection localeId="rehabilitation.sections.dates">
      <FieldSet localeId="rehabilitation.labels.start">
        <FormField name="start" component={Datepicker} />
      </FieldSet>
      <FieldSet localeId="rehabilitation.labels.rehabilitationHasEnded">
        <FormField name="hasEnded" component={RadioButtonGroup} preset="yesno" />
      </FieldSet>

      <ConditionalSection condition={fieldIs('hasEnded', 'yes')}>
        <FieldSet localeId="rehabilitation.labels.end">
          <FormField name="end" component={Datepicker} dateFloorHook="start" />
        </FieldSet>
      </ConditionalSection>
    </FormSection>

    <FormSection localeId="rehabilitation.sections.rehabilitation">
      <FieldSet localeId="rehabilitation.labels.category">
        <FormField
          name="category"
          component={SelectField}
          optionFormatter={optId}
          hintLocale="rehabilitation.hints.category"
          options={[{ value: 'outpatient' }, { value: 'facility' }, { value: 'professional' }, { value: 'other' }]}
        />
      </FieldSet>
      <ConditionalSection condition={fieldExists('category')}>
        <FieldSet localeId="rehabilitation.labels.rehabilitation">
          <ConditionalSection condition={fieldIs('category', 'outpatient')}>
            <FormField
              name="outpatient"
              component={RadioButtonGroup}
              optionFormatter={optId}
              options={[
                { value: 'physiotherapyIndividual' },
                { value: 'physiotherapyGroup' },
                { value: 'lymphaticTherapy' },
                { value: 'pelvicFloorPhysiotherapy' },
                { value: 'poolTherapyIndividual' },
                { value: 'poolTherapyGroup' },
                { value: 'occupationalTherapyIndividual' },
                { value: 'occupationalTherapyGroup' },
                { value: 'neuropsychologicalRehabilitationIndividual' },
                { value: 'neuropsychologicalRehabilitationGroup' },
                { value: 'speechTherapyIndividual' },
                { value: 'speechTherapyGroup' },
                { value: 'multiProfessionalTherapy' },
                { value: 'diseaseInformationGroup' },
                { value: 'adaptationTrainingInpatient' },
                { value: 'horseRidingTherapy' },
                { value: 'evaluationOfRehabilititationNeeds' },
                { value: 'otherOutpatientTherapya' },
              ]}
            />
          </ConditionalSection>

          <ConditionalSection condition={fieldIs('category', 'facility')}>
            <FormField
              name="facility"
              component={RadioButtonGroup}
              optionFormatter={optId}
              options={[
                { value: 'adaptationTrainingInpatient' },
                { value: 'inpatientRehabilitation' },
                { value: 'daytimeRehabilitation' },
                { value: 'otherInpatientRehabilitation' },
              ]}
            />
          </ConditionalSection>

          <ConditionalSection condition={fieldIs('category', 'professional')}>
            <FormField
              name="professional"
              component={RadioButtonGroup}
              optionFormatter={optId}
              options={[
                { value: 'assessmentOfRehabilitationNeed' },
                { value: 'rehabilitationResearch' },
                { value: 'vocationalInpatientRehabilitationPeriod' },
                { value: 'otherVocationalRehabilitation' },
              ]}
            />
          </ConditionalSection>

          <ConditionalSection condition={fieldIs('category', 'other')}>
            <FormField name="other" component={TextFieldBox} hintLocale="rehabilitation.hints.otherRehab" />
          </ConditionalSection>
        </FieldSet>
        <FieldSet localeId="rehabilitation.labels.additionalInfo">
          <FormField
            name="additionalInfo"
            component={TextFieldArea}
            hintLocale="rehabilitation.hints.additionalInfo"
            rows={3}
            viewStyle={{ width: '25rem' }}
            limit={300}
          />
        </FieldSet>
      </ConditionalSection>
    </FormSection>
  </FormProvider>
);

export default RehabilitationForm;
